import { Navigate } from 'react-router-dom';
import type { User } from '../types';

interface AdminRouteProps {
  children: React.ReactNode;
  user: User | null;
  isLoading: boolean;
}

/**
 * Route guard that only allows Connor Admin users.
 * Each app passes its own user via props.
 */
export function AdminRoute({ children, user, isLoading }: AdminRouteProps) {
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-400"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user?.is_connor_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
